export const SET_APP_WIDTH = "SET_APP_WIDTH";

export function setWidth(width) {
    return {
        type: SET_APP_WIDTH,
        width
    }
}
